import { useEffect } from "react";
import { ConnectDragPreview, ConnectDragSource, useDrag } from "react-dnd";
import { UD } from "../../../DnDTypes";
import { DocumentUnit } from "../../../models/DocumentUnit";
import { useAcquireLock } from "../../../hooks/treeLockHooks";

export const useDragElementFromTank = (
  doc: DocumentUnit
): [ConnectDragSource, boolean, ConnectDragPreview] => {
  const acquireLock = useAcquireLock()

  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: UD,
    item: doc,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [doc]);

  useEffect(() => {
    if (isDragging) acquireLock()
  }, [isDragging])

  return [drag, isDragging, preview];
};
